import { render, staticRenderFns } from "./caseIndex.vue?vue&type=template&id=7072dda2&lang=pug"
import script from "./caseIndex.vue?vue&type=script&lang=js"
export * from "./caseIndex.vue?vue&type=script&lang=js"
import style0 from "./caseIndex.vue?vue&type=style&index=0&id=7072dda2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports